import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi';
import { type MaybeRefOrGetter, unref, computed } from 'vue';
import type { WebCitiesAround } from '@/shared/api/experience/types.gen';

export const useAroundCities = (cityId: MaybeRefOrGetter<number | undefined>) => {
  const { getCitiesAround } = useExperienceApi();

  const { data: aroundCities, isFetched } = useQuery({
    queryKey: ['aroundCities', cityId],
    queryFn: async () => {
      const currentCityId = unref(cityId);

      const response = await getCitiesAround({
        path: { cityId: currentCityId as number },
      });

      return response.data;
    },
    enabled: computed(() => !!unref(cityId)),
    retry: false,
  });

  return {
    isFetched,
    aroundCities: computed(() => {
      return aroundCities.value?.filter((city) => !!city.excursions_count) as WebCitiesAround[] | undefined;
    }),
  };
};
